export default __webpack_public_path__ + "static/media/rr.e52ba08f.png";